import React from 'react';
import Select, { StylesConfig } from 'react-select';

const errorColor = '#cc433c';
const gray3Color = '#e9edf3';

export interface SelectInputFieldProps {
  options: Array<any>;
  defaultValue?: DefaultValue;
  className?: string;
  classNamePrefix?: string;
  placeholder?: string;
  noOptionsMessage?: (any) => '';
  isSearchable?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
  onChange?: (value: any) => void;
  isMulti?: boolean;
  closeMenuOnSelect?: boolean;
  hideSelectedOptions?: boolean;
  'aria-label'?: string;
  styles?: StylesConfig;
  hasError: boolean;
  value?: DefaultValue | null;
}

export interface DefaultValue {
  label: string | number;
  value: string | number;
}

export const baseSelectStyles = (hasError = false, selectStyles?: StylesConfig) => {
  return {
    container: (baseStyles, state) => {
      return {
        ...baseStyles,
        ...(selectStyles?.container?.(baseStyles, state) || {}),
        borderRadius: '4px',
        border: '1px solid',
        borderColor: hasError ? errorColor : gray3Color,
        boxShadow: state.isFocused ? '0 0 0 0.2rem #f1ecf0' : ['none'],
      };
    },
    control: (baseStyles, state) => ({
      ...baseStyles,
      ...(selectStyles?.control?.(baseStyles, state) || {}),
      border: 0,
      boxShadow: ['none'],
    }),
    input: (baseStyles, state) => ({
      ...baseStyles,
      ...(selectStyles?.input?.(baseStyles, state) || {}),
      width: state.isFocused ? baseStyles.width : '0px',
      padding: state.isFocused ? baseStyles.padding : '0px',
      margin: state.isFocused ? baseStyles.margin : '0px',
    }),
  };
};

export const fixedWidthSelectStyle = {
  container: (baseStyles, state) => {
    return {
      ...baseStyles,
      width: '200px',
    };
  },
};

export const BaseSelect = (props: SelectInputFieldProps): React.ReactElement => {
  return <Select styles={baseSelectStyles(props.hasError, props.styles)} {...props} />;
};
